import ListSuppliers from "../../../../components/@users/suppliers/ListSuppliers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SuppliersPage() {

    return (
        <ListSuppliers 
            routeType={routeTypes.admin}
        />
    )
}       